<template>
    <kcb-cert ref="kcbCert" @change="payload => redirect(payload)"></kcb-cert>
</template>

<script>
import KcbCert from "@/components/plugins/kcb/kcb-cert.vue";
export default {
    components: {
        KcbCert
    },
    mounted(){
        this.$refs.kcbCert.open();
    },
    methods: {
        redirect(payload){
            window.location.href=`${this.redirectUrl}?_certification=${payload._certification}`;
        }
    },
    computed: {
        redirectUrl(){
            return this.$route.query.redirectUrl;
        }
    }
}
</script>